import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { HostTokenAuthCreateRow, HostTokenAuthRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface HostTokenAuthEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class HostTokenAuthEditPage extends Component<HostTokenAuthEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxString_Host = createRef<NSBoxString>();
    NSABoxSecret_Token = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<HostTokenAuthRow, HostTokenAuthCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Host Token Auth credential by updating its name, host, token, or description. The token is kept as a protected secret, and any application set up to use the credential applies the updated value." : "This section allows you to create a Host Token Auth credential, an API token bound to a specific host, by entering a name, the host, and the token. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then authenticate to that host.",
                }}
                pages={{
                    entity: CredentialEntities.host_token_auth(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): HostTokenAuthCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let host = this.NSBoxString_Host.current?.getValue() ?? "";
                                        let token = this.NSABoxSecret_Token.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            host,
                                            token,
                                            description,
                                            host_token_auth_category: [],
                                            host_token_auth_field: [],
                                            host_token_auth_tag: [],
                                        };
                                    },
                                    setRow: (row: HostTokenAuthRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxString_Host.current?.setValue(row.host);
                                        this.NSABoxSecret_Token.current?.setValue(row.token_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSRow>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            required
                            title="Name"
                            auto_complete="new-password"
                        />
                        <NSBoxString
                            ref={this.NSBoxString_Host}
                            required
                            title="Host"
                        />
                    </NSRow>
                    <NSABoxSecret
                        {...this.props}
                        ref={this.NSABoxSecret_Token}
                        required
                        title="Token"
                        auto_complete="new-password"
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </CredentialLayout >
        );
    }
}